"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_MultiSelectEvent = exports.bpfrpt_proptype_SelectEvent = exports.StiloMultiSelect = exports.RawMultiSelect = exports["default"] = exports.StiloSelect = exports.RawSelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _FormBaseWrapper = _interopRequireDefault(require("../FormBaseWrapper"));

var _DropDown = require("../../DropDown");

var _propTypes = _interopRequireDefault(require("prop-types"));

var bpfrpt_proptype_SelectEvent = {
  "target": _propTypes["default"].shape({
    value: function value() {
      return (typeof V === "function" ? _propTypes["default"].instanceOf(V).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
exports.bpfrpt_proptype_SelectEvent = bpfrpt_proptype_SelectEvent;
var bpfrpt_proptype_MultiSelectEvent = {
  "target": _propTypes["default"].shape({
    value: _propTypes["default"].arrayOf(function () {
      return (typeof V === "function" ? _propTypes["default"].instanceOf(V).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
    }).isRequired
  }).isRequired
};
exports.bpfrpt_proptype_MultiSelectEvent = bpfrpt_proptype_MultiSelectEvent;

var Single = function Single(_ref) {
  var handleChange = _ref.handleChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["handleChange"]);
  return /*#__PURE__*/React.createElement(_DropDown.Dropdown, (0, _extends2["default"])({
    onSelect: handleChange
  }, props));
};

exports.RawSelect = Single;

var StiloSelect = function StiloSelect(props) {
  return /*#__PURE__*/React.createElement(_FormBaseWrapper["default"], (0, _extends2["default"])({}, props, {
    Control: Single
  }));
};

exports["default"] = exports.StiloSelect = StiloSelect;

var Multi = function Multi(_ref2) {
  var value = _ref2.value,
      handleChange = _ref2.handleChange,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["value", "handleChange"]);
  return /*#__PURE__*/React.createElement(_DropDown.MultiDropDown, (0, _extends2["default"])({
    value: value || [],
    onSelect: handleChange
  }, props));
};

exports.RawMultiSelect = Multi;

var StiloMultiSelect = function StiloMultiSelect(props) {
  return /*#__PURE__*/React.createElement(_FormBaseWrapper["default"], (0, _extends2["default"])({}, props, {
    Control: Multi
  }));
};

exports.StiloMultiSelect = StiloMultiSelect;
//# sourceMappingURL=bootstrap.js.map